import { memo, useMemo } from 'react';

import { Box, Flex } from '../index';
import { getStepperLinesColor } from './StepperLines.helpers';
import { StepperLinesProps } from './StepperLines.types';

export const StepperLines = memo<StepperLinesProps>((props) => {
    const { currentStep, stepsCount = 3, color = 'mint100' } = props;

    const steps = useMemo(() => Array.from({ length: stepsCount }, (_, index) => index + 1), [stepsCount]);
    const stepActive = useMemo(() => Math.min(Math.max(currentStep, 1), stepsCount), [currentStep, stepsCount]);

    return (
        <Flex spacing='8' justifyContent='center'>
            {steps.map((number) => (
                <Box
                    key={number}
                    width={stepActive === number ? 80 : 32}
                    height={6}
                    color={getStepperLinesColor(number, stepActive, color)}
                    radius='xsmall'
                />
            ))}
        </Flex>
    );
});

StepperLines.displayName = 'StepperLines';
